import React from "react";
import { useI18n } from "@/i18n/I18nProvider";

const Process = () => {
  const { t } = useI18n();
  return (
    <section id="process" className="py-20 md:py-32 bg-white">
      <div className="zdc-container">
        <div className="max-w-2xl mb-12 md:mb-16">
          <div className="text-xs font-medium uppercase tracking-[0.18em] text-[#2563EB] mb-3">{t.process.eyebrow}</div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-[#111111]">
            {t.process.title}
          </h2>
          <p className="mt-4 text-base md:text-lg text-[#6B7280]">{t.process.subtitle}</p>
        </div>

        <div className="relative">
          {/* Vertical timeline line (desktop) */}
          <div className="absolute left-6 md:left-1/2 top-2 bottom-2 w-px bg-gradient-to-b from-[#E5E7EB] via-[#2563EB]/30 to-[#E5E7EB] md:-translate-x-1/2" />

          <div className="space-y-7 md:space-y-12">
            {t.process.steps.map((step, i) => {
              const isRight = i % 2 === 1;
              return (
                <div key={i} className={`relative grid md:grid-cols-2 gap-6 items-center ${isRight ? "md:[&>*:first-child]:order-2" : ""}`}>
                  {/* Step content */}
                  <div className={`pl-16 md:pl-0 ${isRight ? "md:pl-12 md:text-left" : "md:pr-12 md:text-right"}`}>
                    <div className="text-xs font-medium uppercase tracking-wider text-[#2563EB] mb-2">Step {step.n}</div>
                    <h3 className="font-display text-xl md:text-2xl font-semibold text-[#111111] mb-2">{step.title}</h3>
                    <p className="text-sm md:text-base text-[#6B7280] leading-relaxed">{step.desc}</p>
                  </div>

                  {/* Node circle */}
                  <div className="absolute left-6 md:left-1/2 top-1 md:-translate-x-1/2 -translate-x-1/2">
                    <div className="w-10 h-10 rounded-full bg-[#111111] text-white flex items-center justify-center font-display font-semibold text-sm shadow-[0_8px_20px_rgba(17,17,17,0.2)]">
                      {step.n}
                    </div>
                  </div>

                  {/* Spacer for opposite column */}
                  <div className="hidden md:block" />
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Process;
